import { getFilterScope, type Scope } from '@statsbomb/kitbag-global-football/state';
import { useCallback } from 'react';
import type { FilterValues } from '@statsbomb/parachute-types';

// Migrate this into KGF where the responsibility should be
export const useUpdateFilters = (scope: Scope = 'main') => {
  const updateFilters = useCallback(
    (filters: Partial<FilterValues>) => {
      getFilterScope(scope).patch(filters);
    },
    [scope],
  );

  return { updateFilters };
};
